export default {
      id: "arrow-right-2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#arrow-right-2-usage",
      toString: function () {
        return this.url;
      }
    }